import { combineReducers } from 'redux';

import activities from './reducers/activities';
import callConsoleData from './reducers/call_console';
import results from './reducers/results';
import ui from './reducers/ui';
import criteria from './reducers/criteria';
import offMarketProperty from './reducers/off_market_property';
import savedSearch from './reducers/saved_search';

const reducer = combineReducers({
  activities,
  criteria,
  callConsoleData,
  results,
  savedSearch,
  offMarketProperty,
  ui
});

export type RootState = ReturnType<typeof reducer>;
export default reducer;
